<script setup>
const user = useState('user');
const client = useSupabaseClient();
const { transitionColour } = useTailwindConfig();

// Unit selection handler
async function unitSelected(newUnit) {
  if (newUnit === user.value.unit) {
    // If they clicked the same one, choose the other one
    newUnit = newUnit === 'Imperial' ? 'Metric' : 'Imperial';
  }

  if (newUnit !== user.value.unit) {
    const error = await client
      .from("profiles")
      .update({ unit: newUnit })
      .eq("id", user.value.id);

    user.value.unit = newUnit;

    if (error) {
      pushResponseMessage(error.message, false);
    }
    else {
      pushResponseMessage("Updated Unit");
    }
  }
}
</script>

<template>
  <div class="flex gap-0.5 p-0.5 rounded-lg border border-primary-500/20 h-7" :class="transitionColour">
    <button @click="unitSelected('Imperial')"
      class="px-2 py-1 text-xs font-medium rounded-md transition-all duration-200 h-full" :class="[
        user.unit === 'Imperial'
          ? 'bg-primary-500 text-white'
          : 'text-gray-600 hover:text-primary-500 hover:bg-primary-500/10'
      ]">
      Imperial
    </button>

    <button @click="unitSelected('Metric')"
      class="px-2 py-1 text-xs font-medium rounded-md transition-all duration-200 h-full" :class="[
        user.unit === 'Metric'
          ? 'bg-primary-500 text-white'
          : 'text-gray-600 hover:text-primary-500 hover:bg-primary-500/10'
      ]">
      Metric
    </button>
  </div>
</template>